/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Options_ErrorInputs */



/**
* | output |
* | --- |
* | "The choices could not be loaded. Please try again." |
*
* @param {Spaces_Modular_Wizard_Options_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_options_error = /** @type {((inputs?: Spaces_Modular_Wizard_Options_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Options_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Auswahl konnte nicht geladen werden. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("The choices could not be loaded. Please try again.")
});